import {ICellRendererParams} from '../types/AgGridTypes';

export function EmptyHeaderCellRenderer(props: ICellRendererParams) {
  return <span />;
}
